import React from "react";
import { NextSeo } from "next-seo";
import { getOpenGraphImagesFromSEOContentModel } from "./helpers";
import { PageSEOProps } from "./types";

export function PageSEO(props: PageSEOProps) {
  return (
    <NextSeo
      title={props.seo?.seoTitle ?? undefined}
      description={props.seo?.seoDescription ?? undefined}
      openGraph={getOpenGraphImagesFromSEOContentModel(props?.seo)}
    />
  );
}
